// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1093d","notes":"Notes_notes__3F3PR","note":"Notes_note__1CToK","markdown":"Notes_markdown__2YPel"};